import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import YouTube from 'react-youtube';
import { Link } from 'react-router-dom';

import { searchForElements } from '../../APIClient/blog';
import { getAffiliateLink } from '../../Helpers/attribution_helpers';
import { getNameWithS } from '../../Helpers/user_helpers';
import { getYoutubeVideoIdFromUrl } from '../../Helpers/social_helpers';

import './BlogPostElement.scss';

import CollectionPreview from '../CollectionPreview/CollectionPreview';

class BlogPostElement extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    element: PropTypes.object.isRequired,
    editBlogPostElement: PropTypes.func.isRequired,
    isEditing: PropTypes.bool,
    deleteIcon: PropTypes.object,
    dragHandle: PropTypes.object
  };

  state = {
    curSearch: '',
    searchResults: [],
    curText: this.props.element.text || '',
    curSubtext: this.props.element.subtext || '',
    curImage: this.props.element.image || '',
    curDisclaimer: this.props.element.disclaimer || '',
    curUser_id: this.props.element.User_id || null,
    curPin_id: this.props.element.Pin_id || null,
    curCollection_id: this.props.element.Collection_id || null
  };

  needsUpdate = () =>
    this.props.element.text !== this.state.curText ||
    this.props.element.subtext !== this.state.curSubtext ||
    this.props.element.image !== this.state.curImage ||
    this.props.element.disclaimer !== this.state.curDisclaimer ||
    this.props.element.User_id !== this.state.curUser_id ||
    this.props.element.Pin_id !== this.state.curPin_id ||
    this.props.element.Collection_id !== this.state.curCollection_id;

  update = () => {
    if (this.needsUpdate()) {
      this.props.editBlogPostElement(this.props.element, {
        text: this.state.curText,
        subtext: this.state.curSubtext,
        image: this.state.curImage,
        disclaimer: this.state.curDisclaimer,
        User_id: this.state.curUser_id,
        Pin_id: this.state.curPin_id,
        Collection_id: this.state.curCollection_id
      });
    }
  };

  componentDidMount() {
    this.editElementDebouncer = AwesomeDebouncePromise(this.update, 1200);
  }

  formattedTextEl = text => {
    const parts = _.filter(_.split(text, '(('));
    const allowEnters = text => {
      const parts = text.split('\n');
      return _.map(_.map(parts, (el, idx) => [<span key={idx + '-'}>{el}</span>, idx !== parts.length - 1 ? <br key={idx + 'br'} /> : null]));
    };
    const partsEl = _.flatten(
      parts.map((part, idx) => {
        let url;
        const els = part.split('))');
        if (els.length <= 1) return allowEnters(part);
        const partToChange = els[0];
        const type = els[1].split(' ')[0].split('=')[0];
        let partToKeep = els[1].slice(type.length);

        switch (type) {
          case 'i':
            // ((name in italics))i // TODO: make sure italics also work when at the end of a paragraph or sentence
            return [<i key={idx}>{allowEnters(partToChange)}</i>, allowEnters(partToKeep)];
          case 'b':
            // ((name in bold))i
            return [<b key={idx}>{allowEnters(partToChange)}</b>, allowEnters(partToKeep)];
          case 'bi':
            // ((name in bold italics))bi
            return [
              <i>
                <b key={idx}>{allowEnters(partToChange)}</b>
              </i>,
              allowEnters(partToKeep)
            ];
          case 'u':
            // ((name in underline))u
            return [<u key={idx}>{allowEnters(partToChange)}</u>, allowEnters(partToKeep)];
          case 'l':
            // ((link name))=l=https://google.com
            url = partToKeep.split(' ')[0].slice(1);
            partToKeep = partToKeep.slice(url.length + 1);
            return [
              <a target='_blank' rel='noopener noreferrer' href={url}>
                {partToChange}
              </a>,
              allowEnters(partToKeep)
            ];

          case 'il':
            // ((link name))=l=https://google.com.
            url = partToKeep
              .split(' ')[0]
              .slice(1)
              .split('.')[0];
            partToKeep = partToKeep.slice(url.length + 1);
            return [
              <i>
                <a target='_blank' rel='noopener noreferrer' href={url}>
                  {partToChange}
                </a>
              </i>,
              allowEnters(partToKeep)
            ];

          default:
            return els;
        }
      })
    );

    return partsEl;
  };

  searchForItemInput = type => {
    const { element } = this.props;
    const { curSearch, searchResults } = this.state;
    let placeholder, selectValue;
    switch (type) {
      case 'USER':
        placeholder = 'Search for user by name';
        selectValue = user => {
          this.setState(
            {
              curUser_id: user.id,
              searchResults: [],
              curSearch: '',
              curSubtext: element.type === 'SHOP' ? user.description : this.state.curSubtext
            },
            this.update
          );
        };
        break;
      case 'PIN':
        placeholder = 'Search for pin by title';
        selectValue = pin => {
          this.setState(
            {
              curCollection_id: pin.collection_id,
              curPin_id: pin.id,
              curUser_id: pin.user_id,
              searchResults: [],
              curSearch: ''
            },
            this.update
          );
        };
        break;
      case 'COLLECTION':
        placeholder = 'Search for collection by name';
        selectValue = collection => {
          this.setState(
            {
              curCollection_id: collection.id,
              searchResults: [],
              curSearch: ''
            },
            this.update
          );
        };
        break;

      default:
        break;
    }
    this.searchForItemDebouncer = AwesomeDebouncePromise(async value => {
      if (!this.state.curSearch.length) {
        this.setState({ searchResults: [] });
      } else {
        const resp = await searchForElements(value, type);
        this.setState({
          searchResults: resp.results
        });
      }
    }, 600);
    return (
      <div className='search-results-container'>
        <input
          className='search-result-input'
          placeholder={placeholder}
          onChange={({ target }) => {
            this.setState({ curSearch: target.value });
            this.searchForItemDebouncer(target.value);
          }}
          value={curSearch}
        />
        {!!searchResults.length && (
          <div className='search-results-panel'>
            {_.map(searchResults, (result, idx) => {
              switch (type) {
                case 'USER':
                  return (
                    <div key={result.name + idx} onClick={() => selectValue(result)} className='search-result'>
                      <div className='main'>{result.name}</div>
                      <div className='main'>{result.username}</div>
                    </div>
                  );
                case 'PIN':
                  return (
                    <div key={result.title + idx} onClick={() => selectValue(result)} className='search-result'>
                      <div className='main'>{result.title}</div>
                      <div className='secondary'>by {result.user_name}</div>
                      <div className='tertiary'>from {result.collection_name}</div>
                    </div>
                  );
                case 'COLLECTION':
                  return (
                    <div key={result.collection_name + idx} onClick={() => selectValue(result)} className='search-result'>
                      <div className='main'>{result.collection_name}</div>
                      <div className='secondary'>by {result.user_name}</div>
                    </div>
                  );
                default:
                  return null;
              }
            })}
          </div>
        )}
      </div>
    );
  };

  handleScrollTop = (event, type) => {
    window.scrollTo(0, 0);
  };

  render() {
    const { isEditing, element, dragHandle, deleteIcon } = this.props;
    const { curText, curImage, curDisclaimer, curSubtext } = this.state;
    const { type, image, disclaimer, user, pin, collection } = element;
    let elementDiv;

    switch (type) {
      case 'PARAGRAPH':
        elementDiv = isEditing ? (
          <div className='paragraph block'>
            <textarea
              className='text-input'
              placeholder='Paragraph Text Here'
              onChange={({ target }) => {
                this.setState({ curText: target.value });
                this.editElementDebouncer();
              }}
              rows={6}
              value={curText}
            />
          </div>
        ) : (
          <p className='paragraph block live'>
            {this.formattedTextEl(curText).map((a, idx) => (
              <Fragment key={idx}>{a}</Fragment>
            ))}
          </p>
        );
        break;
      case 'HEADER':
      case 'HEADER_LARGE':
        elementDiv = isEditing ? (
          <div
            className={classnames('header block', {
              large: type === 'HEADER_LARGE'
            })}
          >
            <input
              className='text-input'
              placeholder='Header Text Here'
              onChange={({ target }) => {
                this.setState({ curText: target.value });
                this.editElementDebouncer();
              }}
              value={curText}
            />
          </div>
        ) : (
          <p
            className={classnames('header block live', {
              large: type === 'HEADER_LARGE'
            })}
          >
            {curText}
          </p>
        );
        break;
      case 'BANNER_IMAGE':
        elementDiv = isEditing ? (
          <div className='banner-image block'>
            <div className='banner-image-wrapper'>
              {image || curImage ? <img alt='Explanation' src={image || curImage} /> : <div className='empty' />}
              {curDisclaimer && <div className='disclaimer'>{curDisclaimer}</div>}
            </div>
            <input
              className='text-input'
              placeholder='Image URL'
              onChange={({ target }) => {
                this.setState({ curImage: target.value });
                this.editElementDebouncer();
              }}
              value={curImage}
            />
            <input
              className='discplaimer-input'
              placeholder='Disclaimer Text Here'
              onChange={({ target }) => {
                this.setState({ curDisclaimer: target.value });
                this.editElementDebouncer();
              }}
              value={curDisclaimer}
            />
          </div>
        ) : (
          <div className='banner-image block live'>
            <div className='banner-image-wrapper'>
              {image || curImage ? <img alt='Explanation' src={image} /> : <div className='empty' />}
              {disclaimer && <div className='disclaimer'>{disclaimer}</div>}
            </div>
          </div>
        );
        break;
      case 'QUOTE_FULL':
      case 'QUOTE_HALF':
        elementDiv = (
          <div
            className={classnames('quote block', {
              live: !isEditing,
              half: type === 'QUOTE_HALF'
            })}
          >
            <Link to={user ? `/${user.username}` : '/home'} onClick={this.handleScrollTop} className='user-container'>
              {user ? <img src={user.image} alt={user.name} /> : <div className='empty' />}
              <div className='user-data'>
                <div className='name'>{user ? user.name : 'Artist Name'}</div>
                {isEditing ? (
                  <input
                    className='text-input'
                    placeholder='User tag, ex: celebrity makeup artist'
                    onChange={({ target }) => {
                      this.setState({ curSubtext: target.value });
                      this.editElementDebouncer();
                    }}
                    value={curSubtext}
                  />
                ) : (
                  <div className='subtext'>{curSubtext || 'Add artist tag'}</div>
                )}
              </div>
            </Link>
            {isEditing ? (
              <textarea
                className='subtext-input'
                placeholder='Quote here, do not need to use quotes'
                rows={3}
                onChange={({ target }) => {
                  this.setState({ curText: target.value });
                  this.editElementDebouncer();
                }}
                value={curText}
              />
            ) : (
              curText && <div className='quote-body'>"{curText}"</div>
            )}
            {isEditing && this.searchForItemInput('USER')}
          </div>
        );
        break;

      case 'SHOP':
        elementDiv = (
          <div className={classnames('shop block', { live: !isEditing })}>
            <div className='shop-user-container'>
              {user ? <img src={user.image} alt={user.name} /> : <div className='empty' />}
              <div className='user-data'>
                <div className='name'>{user ? user.name : 'Artist Name'}</div>
                {isEditing ? (
                  <textarea
                    className='text-input'
                    placeholder='Artist bio'
                    rows={3}
                    onChange={({ target }) => {
                      this.setState({ curSubtext: target.value });
                      this.editElementDebouncer();
                    }}
                    value={curSubtext}
                  />
                ) : (
                  <>
                    <div className='subtext'>{curSubtext || 'Add artist bio'}</div>
                    {user && (
                      <Link to={user ? `/${user.username}` : '/home'} onClick={this.handleScrollTop} className='see-all-link'>
                        <div className='see-all-link'>VIEW {getNameWithS(user).full} RECOMMENDATIONS</div>
                      </Link>
                    )}
                  </>
                )}
              </div>
            </div>
            {isEditing && this.searchForItemInput('USER')}
          </div>
        );
        break;
      case 'PIN_FULL':
      case 'PIN_HALF':
        elementDiv = (
          <div
            className={classnames('pin block', {
              live: !isEditing,
              half: type === 'PIN_HALF'
            })}
          >
            <div className='pin-container'>
              <div className='pin-product'>
                <div className='image-container'>{pin ? <img src={pin.image} alt={pin.title} /> : <div className='empty' />}</div>
                <div className='title'>{pin ? pin.title : 'Pin Title'}</div>
              </div>
              <a
                className='shop-now-btn'
                target='_blank'
                rel='noopener noreferrer nofollow'
                href={pin ? getAffiliateLink(pin, this.props.user, pin.user) : '/#'}
              >
                SHOP NOW
              </a>
            </div>
            {isEditing && this.searchForItemInput('PIN')}
          </div>
        );
        break;
      case 'COLLECTION_SHELF':
        elementDiv = (
          <div className={classnames('collection block', { live: !isEditing })}>
            {collection && (
              <CollectionPreview
                fluid
                user={this.props.user}
                collection={collection}
                feature={{
                  tag: null,
                  user: collection.user
                }}
              />
            )}
            {isEditing && !collection && this.searchForItemInput('COLLECTION')}
          </div>
        );
        break;
      case 'YOUTUBE':
        elementDiv = (
          <div className={classnames('youtube block', { live: !isEditing })}>
            <YouTube
              videoId={getYoutubeVideoIdFromUrl(curText)}
              className='youtube-video'
              opts={{
                width: '100%',
                playerVars: {
                  modestbrand: 1,
                  rel: 0
                }
              }}
            />
            {isEditing && (
              <>
                <input
                  placeholder='Youtube URL Here'
                  onChange={({ target }) => {
                    this.setState({ curText: target.value });
                    this.editElementDebouncer();
                  }}
                  value={curText}
                />
              </>
            )}
          </div>
        );
        break;
      case 'INSTAGRAM':
      case 'INSTAGRAM_LARGE':
        elementDiv = (
          <div
            className={classnames('banner-image instagram block', {
              live: !isEditing
            })}
          >
            <div className='banner-image-wrapper'>{image ? <img alt='Explanation' src={image} /> : <div className='empty'></div>}</div>
            {isEditing && (
              <>
                <input
                  placeholder='Instagram URL Here'
                  onChange={({ target }) => {
                    this.setState({ curText: target.value });
                    this.editElementDebouncer();
                  }}
                  value={curText}
                />
              </>
            )}
          </div>
        );
        break;
      case 'LINE':
        elementDiv = <div className={classnames('line block', { live: !isEditing })}></div>;
        break;
      case 'SPACER':
      case 'SPACER_SMALL':
        elementDiv = (
          <div
            className={classnames('spacer block', {
              live: !isEditing,
              small: type === 'SPACER_SMALL'
            })}
          ></div>
        );
        break;
      case 'DISCLAIMER':
        elementDiv = (
          <div className='disclaimer block'>
            The products featured here may contain affiliate links, meaning Shop My Shelf, Inc or the artists may earn a commission on products
            purchased through links to retailer sites.
          </div>
        );
        break;
      default:
        elementDiv = `Unknown Type ${type}`;
        break;
    }

    const half = ['QUOTE_HALF', 'PIN_HALF'].includes(type);
    return (
      <div
        className={classnames('blog-post-element-outer-container', {
          half,
          full: !half
        })}
      >
        <div className='controls-header'>
          {dragHandle}
          {deleteIcon}
        </div>
        {elementDiv}
      </div>
    );
  }
}

export default BlogPostElement;
